import { useSignal } from "@preact/signals";
import { ValueItem } from "$store/components/search/Filters.tsx";
import Icon from "$store/components/ui/Icon.tsx";
import type { FilterToggleValue } from "apps/commerce/types.ts";
import type { ChangeEvent } from "preact/compat";

export default function BrandsFilter(
  { values }: { values: FilterToggleValue[] },
) {
  const brands = useSignal<FilterToggleValue[]>(values);

  const handleFilter = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.currentTarget.value;

    brands.value = values.filter((item) =>
      item.label.toLowerCase().includes(value.toLowerCase())
    );
  };

  return (
    <div class="mt-3">
      <div class="relative">
        <input
          class="w-full h-9 pl-2.5 pr-10 rounded-[10px] outline-tw-primary-100 bg-tw-base-100 bg-opacity-50 text-sm placeholder:text-tw-neutral-400 placeholder:font-semibold"
          type="text"
          placeholder="Digite a marca"
          onChange={handleFilter}
        />

        <Icon
          id="MagnifyingGlass"
          class="text-tw-primary-100 absolute top-1/2 -translate-y-1/2 right-2.5"
          width={20}
          height={20}
        />
      </div>

      <ul class="max-h-80 overflow-y-auto mt-3 grid gap-3 scrollbar">
        {brands.value.map((item) => <ValueItem {...item} />)}
      </ul>
    </div>
  );
}
